var _path, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92383 4V33.5496C3.92383 33.7983 4.1255 34 4.37427 34H33.9238",
    stroke: "black",
    strokeWidth: 0.900888,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7974,
    cy: 23.7183,
    r: 6.80419,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.450444,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2743,
    cy: 10.4373,
    r: 3.2811,
    fill: "#191919"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.0918,
    cy: 26.1309,
    r: 3.83207,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.450444,
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.478,
    cy: 16.809,
    r: 5.9516,
    fill: "#191919",
    stroke: "black",
    strokeWidth: 0.450444
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.601,
    cy: 15.6879,
    r: 5.9516,
    fill: "#E3D6C7",
    stroke: "black",
    strokeWidth: 0.450444
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/ShopIcon.5ae781760c6d3107eda1e95f90bdb262.svg";
export { ForwardRef as ReactComponent };